// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__gl4fq","header":"MessagesList_header__285Ny","chat":"MessagesList_chat__gIVXC"};